import { render, staticRenderFns } from "./ChosenDateTags.vue?vue&type=template&id=952a652a"
import script from "./ChosenDateTags.vue?vue&type=script&lang=ts"
export * from "./ChosenDateTags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports